export default "__VITE_ASSET__DCiTWu5B__"